var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"video-container"},[_c('video',{staticClass:"video",attrs:{"src":_vm.videoLink,"id":"videoPlay","controls":"controls","oncontextmenu":"return false;","controlslist":"nodownload"}},[_vm._v(" 您的浏览器不支持 video 视屏播放。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }